// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { publicConfig } from '@/lib/public-config';

const SUPABASE_URL = publicConfig.supabaseUrl;
const SUPABASE_PUBLISHABLE_KEY = publicConfig.supabasePublishableKey;

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});
